import React from 'react';
import './LeagueTable.css'; // Import CSS file for styling

const calculatePoints = (matches) => {
  const teams = {};


  matches.forEach((match) => {
    if (!teams[match.home_team.name]) {
        console.log(match.home_team.name);
      teams[match.home_team.name] = {
        name: match.home_team.name,
        played: 0,
        wins: 0,
        losses: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        points: 0,
      };
    }

    if (!teams[match.away_team.name]) {
      teams[match.away_team.name] = {
        name: match.away_team.name,
        played: 0,
        wins: 0,
        losses: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        points: 0,
      };
    }


   // Checking both home_team and away_team scores before using them
   if (
    match.score
  ) {
    teams[match.home_team.name].played += 1;
    teams[match.away_team.name].played += 1;
    teams[match.home_team.name].goalsFor += match.score.home_team;
    teams[match.away_team.name].goalsFor += match.score.away_team;
    teams[match.home_team.name].goalsAgainst += match.score.away_team;
    teams[match.away_team.name].goalsAgainst += match.score.home_team;

    if (match.score.home_team > match.score.away_team) {
      teams[match.home_team.name].wins += 1;
      teams[match.home_team.name].points += 3;
      teams[match.away_team.name].losses += 1;
    } else if (match.score.home_team < match.score.away_team) {
      teams[match.away_team.name].wins += 1;
      teams[match.away_team.name].points += 3;
      teams[match.home_team.name].losses += 1;
    } else {
      teams[match.home_team.name].points += 1;
      teams[match.away_team.name].points += 1;
    }
  }
});

  const sortedTeams = Object.values(teams).sort((a, b) => {
    if (a.points === b.points) {
      return b.goalsFor - a.goalsFor;
    }
    return b.points - a.points;
  });

  return sortedTeams.map((team, index) => ({
    rank: index + 1,
    teamName: team.name,
    gamesPlayed: team.played,
    wins: team.wins,
    losses: team.losses,
    goals: `${team.goalsFor}:${team.goalsAgainst}`,
    goalDifference: team.goalsFor - team.goalsAgainst,
    points: team.points,
  }));
};

const LeagueTable = ({ matches }) => {
  const tableData = calculatePoints(matches);

  return (
    <div>
      <table className="league-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Team</th>
            <th>GP</th>
            <th>W</th>
            <th>L</th>
            <th>Goals</th>
            <th>+/-</th>
            <th>Points</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((team, index) => (
            <tr key={index}>
              <td>{team.rank}</td>
              <td>{team.teamName}</td>
              <td>{team.gamesPlayed}</td>
              <td>{team.wins}</td>
              <td>{team.losses}</td>
              <td>{team.goals}</td>
              <td>{team.goalDifference}</td>
              <td>{team.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeagueTable;
